import Vue from 'vue';
import axios from 'axios';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DashboardPlugin from '@/plugins/dashboard-plugin';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLogger from 'vue-logger-plugin';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDT0mhzmZrzy_eG4kZJ5LZ3cipRbJVDVKY',
    // v: '3.26',
    libraries: 'places'
  },
  // Demonstrating how we can customize the name of the components
  installComponents: true
});
Vue.use(DashboardPlugin);
Vue.use(Loading, {
  'is-full-page': true,
  color: '#172b4d',
  loader: 'dots'
});
Vue.use(VueLogger, {logLevel: 'debug', stringifyArguments: true, showLogLevel: true, showMethodName: true, separator: '|', showConsoleColors: true})


/* eslint no-new: 0 */
new Vue({
  el: '#app',
  comments: false,
  render: (h) => h(App),
  router,
  store
});
